import React, { FC, useEffect, useState } from "react"
import { Modal } from "../../features/Modal/Modal"
import { getMessage } from "../../msgs/msgs"
import { DataTable, type DataTableColumn } from "../DataTable/DataTable"

type LogRow = { [key: string]: string | number }

type LogModalProps = {
  isOpen: boolean
  getData: () => Promise<LogRow[]>
  onClose: () => void
}

export const LogModal: FC<LogModalProps> = (props) => {
  const { isOpen, onClose, getData } = props
  const [tableData, setTableData] = useState<LogRow[]>([])
  useEffect(() => {
    isOpen &&
      getData().then((data) => {
        setTableData(data)
      })
  }, [isOpen])
  return (
    <Modal
      isOpen={isOpen}
      header="История операций"
      content={<LogTable data={tableData} />}
      onClose={onClose}
      onOk={onClose}
      hideCancelBtn
    />
  )
}

type LogTableProps = {
  data?: LogRow[]
}
const LogTable: FC<LogTableProps> = (props) => {
  const { data } = props
  if (!data?.length) {
    return <span>Нет данных для отображения</span>
  }

  const columns: DataTableColumn<LogRow>[] = Object.keys(data[0]).map(
    (key, index) => ({
      key: key + "-col-" + index,
      header: getMessage(key),
      cell: (row) => {
        let value = row[key] as string | number
        if (key === "date") {
          value = new Date(value).toLocaleString()
        }
        return value
      },
    }),
  )

  return (
    <DataTable
      columns={columns}
      data={data}
      rowKey={(row) => row.id as string}
    />
  )
}
